import useInput from "../hooks/use-input";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect, useEffect } from "react";
import CardGroup from "../../../components/inputs/card-group/card-group";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormCardSelect = (props) => {
  const { ref, bind } = useInput(props);

  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const {
    translatedOptions = [],
  } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      // Register as ref in form on mount
      register(props.id || props.name, ref);

      // Deregister as ref in form on unmount
      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);


  return <CardGroup {...props} {...bind} options={translatedOptions} />;
};

export default FormCardSelect;
